module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICA8ZyBmaWxsPSIjRkZGIj4KICAgIDxwYXRoIGQ9Ik0xNSAyOGM3LjE4IDAgMTMtNS44MiAxMy0xM1MyMi4xOCAyIDE1IDIgMiA3LjgyIDIgMTVzNS44MiAxMyAxMyAxM3ptMCAyQzYuNzE2IDMwIDAgMjMuMjg0IDAgMTUgMCA2LjcxNiA2LjcxNiAwIDE1IDBjOC4yODQgMCAxNSA2LjcxNiAxNSAxNSAwIDguMjg0LTYuNzE2IDE1LTE1IDE1eiIvPgogICAgPHBhdGggZD0iTTE0IDhhMSAxIDAgMCAxIDIgMHYxNGExIDEgMCAwIDEtMiAwVjh6Ii8+CiAgICA8cGF0aCBkPSJNOCAxNmExIDEgMCAwIDEgMC0yaDE0YTEgMSAwIDAgMSAwIDJIOHoiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-plus.svg
// module id = 153
// module chunks = 0